import AppState, { POPUPS } from '@/js/AppState';
import { observer } from 'mobx-react-lite';
import PopupsManager from 'react-sdk/PopupsManager';

import PopupReplayMinigame from '@/components/popups/PopupReplayMinigame/PopupReplayMinigame';
import Button from '@/components/shared/Button/Button';
import Dial from '@cmp/Dial/Dial';
import ObjectiveBar from '@cmp/Hud/ObjectiveBar/ObjectiveBar';
import Map from '@cmp/Map/Map';
import PopupObjective from '@pops/PopupObjective/PopupObjective';
import PopupVue from '@/components/popups/PopupVue/PopupVue';
import classes from './ScreenGame.module.css';

import PopupMinigameSequence from '@/components/popups/PopupMinigameSequence/PopupMinigameSequence';
import PopupMinigameStars from '@/components/popups/PopupMinigameStars/PopupMinigameStars';
import Minigames from '@/js/Minigames/Minigames';
import SaveGame from '@/js/SaveGame';
import SequenceScenario from '@/js/SequenceScenario';
import { useEffect, useState } from 'react';
import Texts from 'react-sdk/Texts';
import { getUrlVar } from 'react-sdk/utils';
import clsx from 'clsx';

import image_cloche from './popup_notif_cloche.png'
import Periods from '@/js/Periods';
import Selection from '@/components/Selection/Selection';
import ChapterBar from '@/components/Hud/ChapterBar/ChapterBar';
import ScoreProgressbar from '@/components/shared/ScoreProgressbar/ScoreProgressbar';

const ScreenGame = () => {

  const [refreshToken, setRefreshToken] = useState(0)

  useEffect(() => {

    if(AppState.test_mg_mode) return

    if(!SaveGame.getState("sequenceIntroVue")) {
      SaveGame.setState("sequenceIntroVue", true)
      SaveGame.save()
    }

  }, []);

  
  let showScoreBar = AppState.period && Minigames.current === null && (PopupsManager.isOpened(POPUPS.FTUE) || PopupsManager.isOpened(POPUPS.MINIGAME_STARS) || !PopupsManager.someOpened) && AppState.period.type !== "selection"
  

  return (
    <div className={classes.ScreenGame}>
      <Map visible={AppState.mapVisible}/> 
      { AppState.period && AppState.period.type === "selection" && <Selection id={ AppState.period.id } /> }

      <div className={clsx(classes.top_hud, AppState.lockHud && classes.locked)} >
        {/* { AppState.period && <div className={classes.period_title}>{ AppState.period.title }</div> } */}

        <div className={classes.top_hud_buttons}>

          { (!PopupsManager.someOpened || PopupsManager.isOpened(POPUPS.FTUE)) && <ChapterBar /> }

          {/* <div className={classes.hud_menu_btn}><Button icon={<FaBars />} /></div> */}
          {/* <div className={classes.hud_mail_btn}><Button icon={<FaEnvelopeOpenText />} /></div> */}

          {/* <div
          className={classes.hud_bell_btn}
          onClick={() => PopupsManager.open(POPUPS.NOUVEAUTES)}
          >
            <Button icon={<FaRegBell />} />
            {GroupMessages.unreadMessages.length > 0 && <div className={classes.hud_notif}></div>}
          </div> */}
        </div>
      </div>

      {AppState.debugMode &&
      <div className={classes.debug}>
        <details>
          <summary>DEBUG</summary>
          <div>
            <button onClick={() => PopupsManager.open(POPUPS.REPLAY_MG)}>Show Replay MG</button>
            <button onClick={() => SequenceScenario.next()}>SequenceScenario.next</button>
            <button onClick={() => { AppState.mapVisible = !AppState.mapVisible }}>Toggle map visible</button> 
            <div>SequenceScenario  : {SequenceScenario.currentElement?.id}</div>
            <button onClick={() => { AppState.dials.debugSkip = !AppState.dials.debugSkip }}>Toggle dialog skip</button> 
            <div>Dialogue skip  : {AppState.dials.debugSkip ? "true" : "false"}</div>
            <button onClick={() => { setRefreshToken(rt => rt + 1) }}>refreshToken</button> 
            </div>
        </details>
      </div>}

      <div className={classes.bottom_hud}>


        { AppState.period?.type !== "selection" && !PopupsManager.isOpened(POPUPS.LOCATION) &&
          <ObjectiveBar />}

        {/* {AppState.soloObjectives.rootObjectives.length > 0 &&
        <ChapterBar />} */}

      </div>

      {PopupsManager.isOpened(POPUPS.NEW_OBJECTIVE) &&
      <PopupObjective />}


      {PopupsManager.isOpened(POPUPS.REPLAY_MG) &&
      <PopupReplayMinigame />}

      {Minigames.current && <PopupMinigameSequence />}

      {PopupsManager.isOpened(POPUPS.MINIGAME_STARS) &&
      <PopupMinigameStars />}

      {PopupsManager.isOpened(POPUPS.LOCATION) &&
      <PopupVue />}

      { AppState.dials && <Dial /> }

      { showScoreBar && <div className={ classes.jauge }>
          <ScoreProgressbar />
        </div>}

      {
        AppState.nextPeriod && !PopupsManager.someOpened && <Button className={classes.next_period} onClick={() => { AppState.launchNextPeriod() }}>{ Texts.get("screen-game-next-period") }</Button>
      }
    </div>
  );
};

export default observer(ScreenGame);
